import React from 'react';
import { shape, string } from 'prop-types';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Link from '@magalu/stereo-ui/atoms/Link';
import Text from '@magalu/stereo-ui/atoms/Text';
import slugfy from 'slugify';
var BlogSubLinksRelated = function BlogSubLinksRelated(_ref) {
  var _data$blogCategoryCon, _parentCategory$subca;
  var data = _ref.data,
    staticProps = _ref["static"];
  var sectionTitle = staticProps == null ? void 0 : staticProps.title;
  var parentCategory = (data == null ? void 0 : (_data$blogCategoryCon = data.blogCategoryContent) == null ? void 0 : _data$blogCategoryCon.parentCategory) || {};
  var buildUrlSubcategory = function buildUrlSubcategory(categoryId, title, id) {
    return "/blog-da-lu/s/".concat(parentCategory == null ? void 0 : parentCategory.categoryId, "/").concat(categoryId, "/").concat(slugfy(title), "/").concat(id).toLowerCase();
  };
  return Boolean(parentCategory == null ? void 0 : (_parentCategory$subca = parentCategory.subcategories) == null ? void 0 : _parentCategory$subca.length) && React.createElement(Flex, {
    flexDirection: "row",
    alignItems: "center",
    "data-testid": "blog-sub-links-container",
    maxWidth: "calc(1366px + 32px)",
    pt: "36px",
    width: "1366px",
    m: "0 auto"
  }, sectionTitle && React.createElement(Text, {
    color: "inherit",
    fontWeight: "medium",
    textAlign: ['center', 'center', 'left'],
    fontSize: 3,
    "data-testid": "blog-sub-links-title"
  }, sectionTitle), React.createElement(Flex, {
    columnGap: 3,
    mt: "2px",
    ml: 2,
    "data-testid": "blog-sub-links-items-container"
  }, parentCategory == null ? void 0 : parentCategory.subcategories.map(function (_ref2) {
    var categoryId = _ref2.categoryId,
      title = _ref2.title,
      id = _ref2.id;
    return React.createElement(Link, {
      alt: title,
      key: "link",
      href: buildUrlSubcategory(categoryId, title, id),
      target: "_blank",
      "data-testid": "blog-sub-link-item"
    }, React.createElement(Flex, {
      bg: "transparent",
      justifyContent: "center",
      alignItems: "center",
      p: 0,
      "data-testid": "blog-sub-link-text"
    }, title));
  })));
};
BlogSubLinksRelated.ssr = true;
process.env.NODE_ENV !== "production" ? BlogSubLinksRelated.propTypes = {
  data: shape({}),
  "static": shape({
    title: string
  })
} : void 0;
BlogSubLinksRelated.defaultProps = {
  data: {
    blogPostContent: {}
  },
  "static": {}
};
export default BlogSubLinksRelated;